import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@ingka/button';
import useAsyncGlobalVariable from '../../../hooks/useAsyncGlobalVariable';

const Chat = ({ cms, storeOpened, activateAnalytics, ariaLabel, colorButton, buttonStyles }) => {
    const { contactLabel, buttonLink } = cms;
    const { exist: isWebchatAvailableExist } = useAsyncGlobalVariable(['isWebchatAvailable']);
    const [disabled, setDisabled] = useState(true);

    const activateContactAndAnalystics = () => {
        activateAnalytics('Button');
        if (buttonLink) return window.location.assign(buttonLink);
        if (window.openWebchat) return window.openWebchat();
        return null;
    };

    useEffect(() => {
        if (!buttonLink) {
            if (window.isWebchatAvailable) {
                setDisabled(!storeOpened || !window.isWebchatAvailable());
            } else {
                setDisabled(true);
            }
        } else {
            setDisabled(!storeOpened);
        }
    }, [isWebchatAvailableExist, buttonLink, storeOpened]);

    return (
        <Button
            data-cy="contactcard-button"
            type={colorButton}
            aria-label={ariaLabel}
            className={buttonStyles}
            onClick={() => activateContactAndAnalystics()}
            disabled={disabled}
        >
            {contactLabel}
        </Button>
    );
};

Chat.propTypes = {
    cms: PropTypes.object,
    activateAnalytics: PropTypes.func,
    ariaLabel: PropTypes.string,
    index: PropTypes.number,
    contactType: PropTypes.string,
    contactLabel: PropTypes.string,
    colorButton: PropTypes.string,
    buttonStyles: PropTypes.string,
    buttonLink: PropTypes.string,
    storeOpened: PropTypes.bool,
};

export default Chat;
